import React from 'react';

import Styled from 'styled';

import CMSLoader from 'four-nets/cms/cms-loader';

import defaultStyles from './hot-content-widget.scss';

interface LoaderProps {
    styles: defaultStyles;
}

interface WidgetProps {
    cmsItem: any;
    styles: defaultStyles;
}

const Widget: React.FC<WidgetProps> = props => {
    const { cmsItem, styles } = props;
    return <div className={styles.wrapper} dangerouslySetInnerHTML={{ __html: cmsItem.content }} />;
};

const WidgetLoader: React.FC<LoaderProps> = props => {
    const { styles } = props;
    return <CMSLoader render={cmsItem => <Widget styles={styles} cmsItem={cmsItem} />} cmsKey='hot-content' />;
};

export default Styled(defaultStyles)(WidgetLoader);
